var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.536 30.744L0 61.28L2.816 64.184L5.72 67L19.096 53.624L32.472 40.248L35.2 42.8L37.928 45.44L46.992 36.2C57.112 25.816 61.864 17.808 62.92 9.36C63.536 4.52 63.008 0.120003 61.776 0.120003C61.424 0.120003 47.432 13.848 30.536 30.744Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_215_186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 67
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.536 30.744L0 61.28L2.816 64.184L5.72 67L19.096 53.624L32.472 40.248L35.2 42.8L37.928 45.44L46.992 36.2C57.112 25.816 61.864 17.808 62.92 9.36C63.536 4.52 63.008 0.120003 61.776 0.120003C61.424 0.120003 47.432 13.848 30.536 30.744Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_215_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9876 16.0038C63.5748 16.1342 66.3824 18.1078 67.1129 20.6231C67.8972 23.323 63.9439 25.8028 64.6262 28.531C65.4477 31.8156 70.9238 32.7744 70.9992 36.1617C71.0634 39.0445 67.2241 40.3327 64.9269 42.0384C62.6926 43.6974 60.5223 46.0824 57.7524 45.9978C54.9774 45.9131 53.4586 42.448 50.8096 41.6072C47.8164 40.6571 43.4687 43.4081 41.5879 40.8672C39.6872 38.2995 42.9666 34.7633 43.3901 31.5838C43.6832 29.3837 43.091 27.1786 43.6956 25.0446C44.3433 22.7584 44.8741 19.9079 46.9908 18.8748C49.1868 17.8029 51.7095 20.4569 54.0989 19.9668C56.7324 19.4266 58.3038 15.8684 60.9876 16.0038Z",
    fill: "url(#paint0_linear_215_186)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_215_186",
    x1: 49.5,
    y1: 12.5,
    x2: 60,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnife);
export default __webpack_public_path__ + "static/media/knife.786ab9e158256e9cd7fcdfa96e1506c2.svg";
export { ForwardRef as ReactComponent };